import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=187b01bc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('187b01bc')) {
      api.createRecord('187b01bc', component.options)
    } else {
      api.reload('187b01bc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=187b01bc&", function () {
      api.rerender('187b01bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8cHUXqhXUTdLA/JS/offershelp.vue"
export default component.exports